/**
 * Formatadores compartilhados dos widgets do financeiro.
 *
 * Mantidos locais a esta pasta para nao poluir `lib/masks.ts` com mais
 * helpers — apenas widgets do D09 consomem essas funcoes.
 */

export function formatBrl(value: number): string {
  if (!Number.isFinite(value)) return 'R$ 0,00';
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
}

/**
 * Versao compacta para usar quando o KPI fica pequeno (1x1) e o valor
 * inteiro nao cabe. Ex: "R$ 1,2 mil", "R$ 4,5 mi".
 */
export function formatBrlCompact(value: number): string {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    return `R$ ${(value / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} mi`;
  }
  if (abs >= 10_000) {
    return `R$ ${(value / 1_000).toLocaleString('pt-BR', { maximumFractionDigits: 0 })} mil`;
  }
  return formatBrl(value);
}
